/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Service_RequiredInputs */

const vi_carrier_form_service_required = /** @type {(inputs: Carrier_Form_Service_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa chọn dịch vụ vận chuyển. Lấy báo giá và chọn dịch vụ trước khi tạo vận đơn.`)
};

/**

* @param {Carrier_Form_Service_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_service_required = /** @type {((inputs?: Carrier_Form_Service_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Service_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_service_required(inputs)
});